import * as React from "react";
const SvgIcCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 4.667l-8 8L2.333 9l.94-.94L6 10.78l7.06-7.053.94.94z", fill: "#6a707c" }));
export default SvgIcCheck;
